import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-alerts',
  templateUrl: './tutorial-alerts.component.html',
  styleUrls: ['./tutorial-alerts.component.css']
})
export class TutorialAlertsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}